export const replaceCharacter = (input, strip, replacement = '') => {
  return input.split(strip).join(replacement);
};
